@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.transfer_intrabank.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mobile_wallet.feature.transfer_intrabank.generated.resources/"

internal val Res.string.feature_make_transfer_amount: StringResource by lazy {
      StringResource("string:feature_make_transfer_amount", "feature_make_transfer_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105, 52),
      ))
    }

internal val Res.string.feature_make_transfer_amount_error: StringResource by lazy {
      StringResource("string:feature_make_transfer_amount_error", "feature_make_transfer_amount_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 94),
      ))
    }

internal val Res.string.feature_make_transfer_available_balance: StringResource by lazy {
      StringResource("string:feature_make_transfer_available_balance", "feature_make_transfer_available_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158, 79),
      ))
    }

internal val Res.string.feature_make_transfer_badge_saving: StringResource by lazy {
      StringResource("string:feature_make_transfer_badge_saving", "feature_make_transfer_badge_saving", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238, 50),
      ))
    }

internal val Res.string.feature_make_transfer_badge_wallet: StringResource by lazy {
      StringResource("string:feature_make_transfer_badge_wallet", "feature_make_transfer_badge_wallet", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 289, 50),
      ))
    }

internal val Res.string.feature_make_transfer_check_icon_description: StringResource by lazy {
      StringResource("string:feature_make_transfer_check_icon_description", "feature_make_transfer_check_icon_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 340, 60),
      ))
    }

internal val Res.string.feature_make_transfer_continue: StringResource by lazy {
      StringResource("string:feature_make_transfer_continue", "feature_make_transfer_continue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 459, 50),
      ))
    }

internal val Res.string.feature_make_transfer_continue_button: StringResource by lazy {
      StringResource("string:feature_make_transfer_continue_button", "feature_make_transfer_continue_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 401, 57),
      ))
    }

internal val Res.string.feature_make_transfer_description_label: StringResource by lazy {
      StringResource("string:feature_make_transfer_description_label", "feature_make_transfer_description_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 510, 67),
      ))
    }

internal val Res.string.feature_make_transfer_error_empty_amount: StringResource by lazy {
      StringResource("string:feature_make_transfer_error_empty_amount", "feature_make_transfer_error_empty_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 578, 80),
      ))
    }

internal val Res.string.feature_make_transfer_error_empty_description: StringResource by lazy {
      StringResource("string:feature_make_transfer_error_empty_description", "feature_make_transfer_error_empty_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 659, 89),
      ))
    }

internal val Res.string.feature_make_transfer_error_inactive_account: StringResource by lazy {
      StringResource("string:feature_make_transfer_error_inactive_account", "feature_make_transfer_error_inactive_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 749, 80),
      ))
    }

internal val Res.string.feature_make_transfer_error_insufficient_balance: StringResource by lazy {
      StringResource("string:feature_make_transfer_error_insufficient_balance", "feature_make_transfer_error_insufficient_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 830, 84),
      ))
    }

internal val Res.string.feature_make_transfer_error_invalid_amount: StringResource by lazy {
      StringResource("string:feature_make_transfer_error_invalid_amount", "feature_make_transfer_error_invalid_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 915, 86),
      ))
    }

internal val Res.string.feature_make_transfer_error_same_account: StringResource by lazy {
      StringResource("string:feature_make_transfer_error_same_account", "feature_make_transfer_error_same_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1002, 96),
      ))
    }

internal val Res.string.feature_make_transfer_error_select_account: StringResource by lazy {
      StringResource("string:feature_make_transfer_error_select_account", "feature_make_transfer_error_select_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1099, 82),
      ))
    }

internal val Res.string.feature_make_transfer_from_account: StringResource by lazy {
      StringResource("string:feature_make_transfer_from_account", "feature_make_transfer_from_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1247, 54),
      ))
    }

internal val Res.string.feature_make_transfer_from_account_title: StringResource by lazy {
      StringResource("string:feature_make_transfer_from_account_title", "feature_make_transfer_from_account_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1182, 64),
      ))
    }

internal val Res.string.feature_make_transfer_hide_balance: StringResource by lazy {
      StringResource("string:feature_make_transfer_hide_balance", "feature_make_transfer_hide_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1302, 58),
      ))
    }

internal val Res.string.feature_make_transfer_icon_selected_description: StringResource by lazy {
      StringResource("string:feature_make_transfer_icon_selected_description", "feature_make_transfer_icon_selected_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1361, 91),
      ))
    }

internal val Res.string.feature_make_transfer_loading: StringResource by lazy {
      StringResource("string:feature_make_transfer_loading", "feature_make_transfer_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1453, 49),
      ))
    }

internal val Res.string.feature_make_transfer_no_accounts_found: StringResource by lazy {
      StringResource("string:feature_make_transfer_no_accounts_found", "feature_make_transfer_no_accounts_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1503, 71),
      ))
    }

internal val Res.string.feature_make_transfer_oops_title: StringResource by lazy {
      StringResource("string:feature_make_transfer_oops_title", "feature_make_transfer_oops_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1575, 48),
      ))
    }

internal val Res.string.feature_make_transfer_payment_done: StringResource by lazy {
      StringResource("string:feature_make_transfer_payment_done", "feature_make_transfer_payment_done", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1624, 98),
      ))
    }

internal val Res.string.feature_make_transfer_payment_success: StringResource by lazy {
      StringResource("string:feature_make_transfer_payment_success", "feature_make_transfer_payment_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1723, 65),
      ))
    }

internal val Res.string.feature_make_transfer_review_title: StringResource by lazy {
      StringResource("string:feature_make_transfer_review_title", "feature_make_transfer_review_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1789, 62),
      ))
    }

internal val Res.string.feature_make_transfer_send_money: StringResource by lazy {
      StringResource("string:feature_make_transfer_send_money", "feature_make_transfer_send_money", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1852, 56),
      ))
    }

internal val Res.string.feature_make_transfer_sending_to: StringResource by lazy {
      StringResource("string:feature_make_transfer_sending_to", "feature_make_transfer_sending_to", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1909, 56),
      ))
    }

internal val Res.string.feature_make_transfer_show_balance: StringResource by lazy {
      StringResource("string:feature_make_transfer_show_balance", "feature_make_transfer_show_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1966, 58),
      ))
    }

internal val Res.string.feature_make_transfer_success: StringResource by lazy {
      StringResource("string:feature_make_transfer_success", "feature_make_transfer_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2025, 49),
      ))
    }

internal val Res.string.feature_make_transfer_to_account: StringResource by lazy {
      StringResource("string:feature_make_transfer_to_account", "feature_make_transfer_to_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2075, 52),
      ))
    }

internal val Res.string.feature_make_transfer_transaction_success: StringResource by lazy {
      StringResource("string:feature_make_transfer_transaction_success", "feature_make_transfer_transaction_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2128, 81),
      ))
    }

internal val Res.string.feature_make_transfer_transaction_unable_to_process: StringResource by
    lazy {
      StringResource("string:feature_make_transfer_transaction_unable_to_process", "feature_make_transfer_transaction_unable_to_process", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2210, 95),
      ))
    }

internal val Res.string.feature_select_account_placeholder: StringResource by lazy {
      StringResource("string:feature_select_account_placeholder", "feature_select_account_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2306, 86),
      ))
    }

internal val Res.string.feature_select_payment_title: StringResource by lazy {
      StringResource("string:feature_select_payment_title", "feature_select_payment_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2393, 52),
      ))
    }

internal val Res.string.feature_send_money_add_icon_desc: StringResource by lazy {
      StringResource("string:feature_send_money_add_icon_desc", "feature_send_money_add_icon_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2446, 44),
      ))
    }

internal val Res.string.feature_send_money_add_payee: StringResource by lazy {
      StringResource("string:feature_send_money_add_payee", "feature_send_money_add_payee", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2640, 48),
      ))
    }

internal val Res.string.feature_send_money_add_payee_subtitle: StringResource by lazy {
      StringResource("string:feature_send_money_add_payee_subtitle", "feature_send_money_add_payee_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2491, 93),
      ))
    }

internal val Res.string.feature_send_money_add_payee_title: StringResource by lazy {
      StringResource("string:feature_send_money_add_payee_title", "feature_send_money_add_payee_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2585, 54),
      ))
    }

internal val Res.string.feature_send_money_all_accounts: StringResource by lazy {
      StringResource("string:feature_send_money_all_accounts", "feature_send_money_all_accounts", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2689, 55),
      ))
    }

internal val Res.string.feature_send_money_amount: StringResource by lazy {
      StringResource("string:feature_send_money_amount", "feature_send_money_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2745, 41),
      ))
    }

internal val Res.string.feature_send_money_bottom_bar: StringResource by lazy {
      StringResource("string:feature_send_money_bottom_bar", "feature_send_money_bottom_bar", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2787, 53),
      ))
    }

internal val Res.string.feature_send_money_close: StringResource by lazy {
      StringResource("string:feature_send_money_close", "feature_send_money_close", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2841, 40),
      ))
    }

internal val Res.string.feature_send_money_error_account_cannot_be_empty: StringResource by lazy {
      StringResource("string:feature_send_money_error_account_cannot_be_empty", "feature_send_money_error_account_cannot_be_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2882, 88),
      ))
    }

internal val Res.string.feature_send_money_error_amount_cannot_be_empty: StringResource by lazy {
      StringResource("string:feature_send_money_error_amount_cannot_be_empty", "feature_send_money_error_amount_cannot_be_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2971, 87),
      ))
    }

internal val Res.string.feature_send_money_error_fetching_balance: StringResource by lazy {
      StringResource("string:feature_send_money_error_fetching_balance", "feature_send_money_error_fetching_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3059, 81),
      ))
    }

internal val Res.string.feature_send_money_error_invalid_amount: StringResource by lazy {
      StringResource("string:feature_send_money_error_invalid_amount", "feature_send_money_error_invalid_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3141, 67),
      ))
    }

internal val Res.string.feature_send_money_error_requesting_payment_qr_but_found: StringResource by
    lazy {
      StringResource("string:feature_send_money_error_requesting_payment_qr_but_found", "feature_send_money_error_requesting_payment_qr_but_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3209, 116),
      ))
    }

internal val Res.string.feature_send_money_error_requesting_payment_qr_data_missing: StringResource
    by lazy {
      StringResource("string:feature_send_money_error_requesting_payment_qr_data_missing", "feature_send_money_error_requesting_payment_qr_data_missing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3326, 139),
      ))
    }

internal val Res.string.feature_send_money_history: StringResource by lazy {
      StringResource("string:feature_send_money_history", "feature_send_money_history", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3466, 46),
      ))
    }

internal val Res.string.feature_send_money_insufficient_balance: StringResource by lazy {
      StringResource("string:feature_send_money_insufficient_balance", "feature_send_money_insufficient_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3513, 75),
      ))
    }

internal val Res.string.feature_send_money_last_paid: StringResource by lazy {
      StringResource("string:feature_send_money_last_paid", "feature_send_money_last_paid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3589, 56),
      ))
    }

internal val Res.string.feature_send_money_loading: StringResource by lazy {
      StringResource("string:feature_send_money_loading", "feature_send_money_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3646, 46),
      ))
    }

internal val Res.string.feature_send_money_mobile: StringResource by lazy {
      StringResource("string:feature_send_money_mobile", "feature_send_money_mobile", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3693, 53),
      ))
    }

internal val Res.string.feature_send_money_no_accounts_found: StringResource by lazy {
      StringResource("string:feature_send_money_no_accounts_found", "feature_send_money_no_accounts_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3851, 68),
      ))
    }

internal val Res.string.feature_send_money_no_accounts_found_for_search: StringResource by lazy {
      StringResource("string:feature_send_money_no_accounts_found_for_search", "feature_send_money_no_accounts_found_for_search", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3747, 103),
      ))
    }

internal val Res.string.feature_send_money_no_beneficiaries: StringResource by lazy {
      StringResource("string:feature_send_money_no_beneficiaries", "feature_send_money_no_beneficiaries", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4025, 67),
      ))
    }

internal val Res.string.feature_send_money_no_beneficiaries_subtitle: StringResource by lazy {
      StringResource("string:feature_send_money_no_beneficiaries_subtitle", "feature_send_money_no_beneficiaries_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3920, 104),
      ))
    }

internal val Res.string.feature_send_money_no_recents: StringResource by lazy {
      StringResource("string:feature_send_money_no_recents", "feature_send_money_no_recents", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4188, 65),
      ))
    }

internal val Res.string.feature_send_money_no_recents_subtitle: StringResource by lazy {
      StringResource("string:feature_send_money_no_recents_subtitle", "feature_send_money_no_recents_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4093, 94),
      ))
    }

internal val Res.string.feature_send_money_not_allowed: StringResource by lazy {
      StringResource("string:feature_send_money_not_allowed", "feature_send_money_not_allowed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4254, 86),
      ))
    }

internal val Res.string.feature_send_money_oops: StringResource by lazy {
      StringResource("string:feature_send_money_oops", "feature_send_money_oops", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4341, 39),
      ))
    }

internal val Res.string.feature_send_money_pay_button: StringResource by lazy {
      StringResource("string:feature_send_money_pay_button", "feature_send_money_pay_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4381, 41),
      ))
    }

internal val Res.string.feature_send_money_phone_number: StringResource by lazy {
      StringResource("string:feature_send_money_phone_number", "feature_send_money_phone_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4423, 55),
      ))
    }

internal val Res.string.feature_send_money_please_wait: StringResource by lazy {
      StringResource("string:feature_send_money_please_wait", "feature_send_money_please_wait", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4479, 58),
      ))
    }

internal val Res.string.feature_send_money_proceed: StringResource by lazy {
      StringResource("string:feature_send_money_proceed", "feature_send_money_proceed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4538, 46),
      ))
    }

internal val Res.string.feature_send_money_recents_icon_desc: StringResource by lazy {
      StringResource("string:feature_send_money_recents_icon_desc", "feature_send_money_recents_icon_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4585, 56),
      ))
    }

internal val Res.string.feature_send_money_recents_title: StringResource by lazy {
      StringResource("string:feature_send_money_recents_title", "feature_send_money_recents_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4642, 52),
      ))
    }

internal val Res.string.feature_send_money_request: StringResource by lazy {
      StringResource("string:feature_send_money_request", "feature_send_money_request", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4695, 46),
      ))
    }

internal val Res.string.feature_send_money_scan_qr: StringResource by lazy {
      StringResource("string:feature_send_money_scan_qr", "feature_send_money_scan_qr", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4742, 46),
      ))
    }

internal val Res.string.feature_send_money_see_all: StringResource by lazy {
      StringResource("string:feature_send_money_see_all", "feature_send_money_see_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4789, 62),
      ))
    }

internal val Res.string.feature_send_money_select_transfer_method: StringResource by lazy {
      StringResource("string:feature_send_money_select_transfer_method", "feature_send_money_select_transfer_method", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4852, 81),
      ))
    }

internal val Res.string.feature_send_money_selected: StringResource by lazy {
      StringResource("string:feature_send_money_selected", "feature_send_money_selected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4934, 47),
      ))
    }

internal val Res.string.feature_send_money_send: StringResource by lazy {
      StringResource("string:feature_send_money_send", "feature_send_money_send", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4982, 47),
      ))
    }

internal val Res.string.feature_send_money_something_went_wrong: StringResource by lazy {
      StringResource("string:feature_send_money_something_went_wrong", "feature_send_money_something_went_wrong", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5030, 75),
      ))
    }

internal val Res.string.feature_send_money_submit: StringResource by lazy {
      StringResource("string:feature_send_money_submit", "feature_send_money_submit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5106, 41),
      ))
    }

internal val Res.string.feature_send_money_tab_beneficiaries: StringResource by lazy {
      StringResource("string:feature_send_money_tab_beneficiaries", "feature_send_money_tab_beneficiaries", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5148, 64),
      ))
    }

internal val Res.string.feature_send_money_tab_recents: StringResource by lazy {
      StringResource("string:feature_send_money_tab_recents", "feature_send_money_tab_recents", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5213, 50),
      ))
    }

internal val Res.string.feature_send_money_to_account: StringResource by lazy {
      StringResource("string:feature_send_money_to_account", "feature_send_money_to_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5264, 53),
      ))
    }

internal val Res.string.feature_send_money_virtual_payment_address: StringResource by lazy {
      StringResource("string:feature_send_money_virtual_payment_address", "feature_send_money_virtual_payment_address", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5318, 82),
      ))
    }

internal val Res.string.feature_send_money_vpa: StringResource by lazy {
      StringResource("string:feature_send_money_vpa", "feature_send_money_vpa", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5490, 34),
      ))
    }

internal val Res.string.feature_send_money_vpa_mobile_account_number: StringResource by lazy {
      StringResource("string:feature_send_money_vpa_mobile_account_number", "feature_send_money_vpa_mobile_account_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5401, 88),
      ))
    }

internal val Res.string.feature_transfer_amount: StringResource by lazy {
      StringResource("string:feature_transfer_amount", "feature_transfer_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5525, 39),
      ))
    }

internal val Res.string.feature_transfer_back_to_home: StringResource by lazy {
      StringResource("string:feature_transfer_back_to_home", "feature_transfer_back_to_home", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5565, 53),
      ))
    }

internal val Res.string.feature_transfer_cancel: StringResource by lazy {
      StringResource("string:feature_transfer_cancel", "feature_transfer_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5619, 39),
      ))
    }

internal val Res.string.feature_transfer_close: StringResource by lazy {
      StringResource("string:feature_transfer_close", "feature_transfer_close", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5659, 38),
      ))
    }

internal val Res.string.feature_transfer_copy: StringResource by lazy {
      StringResource("string:feature_transfer_copy", "feature_transfer_copy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5698, 37),
      ))
    }

internal val Res.string.feature_transfer_date: StringResource by lazy {
      StringResource("string:feature_transfer_date", "feature_transfer_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5736, 37),
      ))
    }

internal val Res.string.feature_transfer_description: StringResource by lazy {
      StringResource("string:feature_transfer_description", "feature_transfer_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5774, 52),
      ))
    }

internal val Res.string.feature_transfer_error_access_denied_title: StringResource by lazy {
      StringResource("string:feature_transfer_error_access_denied_title", "feature_transfer_error_access_denied_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5827, 70),
      ))
    }

internal val Res.string.feature_transfer_error_invalid_request: StringResource by lazy {
      StringResource("string:feature_transfer_error_invalid_request", "feature_transfer_error_invalid_request", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5971, 106),
      ))
    }

internal val Res.string.feature_transfer_error_invalid_request_title: StringResource by lazy {
      StringResource("string:feature_transfer_error_invalid_request_title", "feature_transfer_error_invalid_request_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5898, 72),
      ))
    }

internal val Res.string.feature_transfer_error_network: StringResource by lazy {
      StringResource("string:feature_transfer_error_network", "feature_transfer_error_network", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6143, 90),
      ))
    }

internal val Res.string.feature_transfer_error_network_title: StringResource by lazy {
      StringResource("string:feature_transfer_error_network_title", "feature_transfer_error_network_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6078, 64),
      ))
    }

internal val Res.string.feature_transfer_error_server: StringResource by lazy {
      StringResource("string:feature_transfer_error_server", "feature_transfer_error_server", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6294, 101),
      ))
    }

internal val Res.string.feature_transfer_error_server_title: StringResource by lazy {
      StringResource("string:feature_transfer_error_server_title", "feature_transfer_error_server_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6234, 59),
      ))
    }

internal val Res.string.feature_transfer_error_title: StringResource by lazy {
      StringResource("string:feature_transfer_error_title", "feature_transfer_error_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6396, 44),
      ))
    }

internal val Res.string.feature_transfer_from_account: StringResource by lazy {
      StringResource("string:feature_transfer_from_account", "feature_transfer_from_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6441, 45),
      ))
    }

internal val Res.string.feature_transfer_retry: StringResource by lazy {
      StringResource("string:feature_transfer_retry", "feature_transfer_retry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6487, 38),
      ))
    }

internal val Res.string.feature_transfer_to_account: StringResource by lazy {
      StringResource("string:feature_transfer_to_account", "feature_transfer_to_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6526, 39),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_make_transfer_amount", Res.string.feature_make_transfer_amount)
  map.put("feature_make_transfer_amount_error", Res.string.feature_make_transfer_amount_error)
  map.put("feature_make_transfer_available_balance", Res.string.feature_make_transfer_available_balance)
  map.put("feature_make_transfer_badge_saving", Res.string.feature_make_transfer_badge_saving)
  map.put("feature_make_transfer_badge_wallet", Res.string.feature_make_transfer_badge_wallet)
  map.put("feature_make_transfer_check_icon_description", Res.string.feature_make_transfer_check_icon_description)
  map.put("feature_make_transfer_continue", Res.string.feature_make_transfer_continue)
  map.put("feature_make_transfer_continue_button", Res.string.feature_make_transfer_continue_button)
  map.put("feature_make_transfer_description_label", Res.string.feature_make_transfer_description_label)
  map.put("feature_make_transfer_error_empty_amount", Res.string.feature_make_transfer_error_empty_amount)
  map.put("feature_make_transfer_error_empty_description", Res.string.feature_make_transfer_error_empty_description)
  map.put("feature_make_transfer_error_inactive_account", Res.string.feature_make_transfer_error_inactive_account)
  map.put("feature_make_transfer_error_insufficient_balance", Res.string.feature_make_transfer_error_insufficient_balance)
  map.put("feature_make_transfer_error_invalid_amount", Res.string.feature_make_transfer_error_invalid_amount)
  map.put("feature_make_transfer_error_same_account", Res.string.feature_make_transfer_error_same_account)
  map.put("feature_make_transfer_error_select_account", Res.string.feature_make_transfer_error_select_account)
  map.put("feature_make_transfer_from_account", Res.string.feature_make_transfer_from_account)
  map.put("feature_make_transfer_from_account_title", Res.string.feature_make_transfer_from_account_title)
  map.put("feature_make_transfer_hide_balance", Res.string.feature_make_transfer_hide_balance)
  map.put("feature_make_transfer_icon_selected_description", Res.string.feature_make_transfer_icon_selected_description)
  map.put("feature_make_transfer_loading", Res.string.feature_make_transfer_loading)
  map.put("feature_make_transfer_no_accounts_found", Res.string.feature_make_transfer_no_accounts_found)
  map.put("feature_make_transfer_oops_title", Res.string.feature_make_transfer_oops_title)
  map.put("feature_make_transfer_payment_done", Res.string.feature_make_transfer_payment_done)
  map.put("feature_make_transfer_payment_success", Res.string.feature_make_transfer_payment_success)
  map.put("feature_make_transfer_review_title", Res.string.feature_make_transfer_review_title)
  map.put("feature_make_transfer_send_money", Res.string.feature_make_transfer_send_money)
  map.put("feature_make_transfer_sending_to", Res.string.feature_make_transfer_sending_to)
  map.put("feature_make_transfer_show_balance", Res.string.feature_make_transfer_show_balance)
  map.put("feature_make_transfer_success", Res.string.feature_make_transfer_success)
  map.put("feature_make_transfer_to_account", Res.string.feature_make_transfer_to_account)
  map.put("feature_make_transfer_transaction_success", Res.string.feature_make_transfer_transaction_success)
  map.put("feature_make_transfer_transaction_unable_to_process", Res.string.feature_make_transfer_transaction_unable_to_process)
  map.put("feature_select_account_placeholder", Res.string.feature_select_account_placeholder)
  map.put("feature_select_payment_title", Res.string.feature_select_payment_title)
  map.put("feature_send_money_add_icon_desc", Res.string.feature_send_money_add_icon_desc)
  map.put("feature_send_money_add_payee", Res.string.feature_send_money_add_payee)
  map.put("feature_send_money_add_payee_subtitle", Res.string.feature_send_money_add_payee_subtitle)
  map.put("feature_send_money_add_payee_title", Res.string.feature_send_money_add_payee_title)
  map.put("feature_send_money_all_accounts", Res.string.feature_send_money_all_accounts)
  map.put("feature_send_money_amount", Res.string.feature_send_money_amount)
  map.put("feature_send_money_bottom_bar", Res.string.feature_send_money_bottom_bar)
  map.put("feature_send_money_close", Res.string.feature_send_money_close)
  map.put("feature_send_money_error_account_cannot_be_empty", Res.string.feature_send_money_error_account_cannot_be_empty)
  map.put("feature_send_money_error_amount_cannot_be_empty", Res.string.feature_send_money_error_amount_cannot_be_empty)
  map.put("feature_send_money_error_fetching_balance", Res.string.feature_send_money_error_fetching_balance)
  map.put("feature_send_money_error_invalid_amount", Res.string.feature_send_money_error_invalid_amount)
  map.put("feature_send_money_error_requesting_payment_qr_but_found", Res.string.feature_send_money_error_requesting_payment_qr_but_found)
  map.put("feature_send_money_error_requesting_payment_qr_data_missing", Res.string.feature_send_money_error_requesting_payment_qr_data_missing)
  map.put("feature_send_money_history", Res.string.feature_send_money_history)
  map.put("feature_send_money_insufficient_balance", Res.string.feature_send_money_insufficient_balance)
  map.put("feature_send_money_last_paid", Res.string.feature_send_money_last_paid)
  map.put("feature_send_money_loading", Res.string.feature_send_money_loading)
  map.put("feature_send_money_mobile", Res.string.feature_send_money_mobile)
  map.put("feature_send_money_no_accounts_found", Res.string.feature_send_money_no_accounts_found)
  map.put("feature_send_money_no_accounts_found_for_search", Res.string.feature_send_money_no_accounts_found_for_search)
  map.put("feature_send_money_no_beneficiaries", Res.string.feature_send_money_no_beneficiaries)
  map.put("feature_send_money_no_beneficiaries_subtitle", Res.string.feature_send_money_no_beneficiaries_subtitle)
  map.put("feature_send_money_no_recents", Res.string.feature_send_money_no_recents)
  map.put("feature_send_money_no_recents_subtitle", Res.string.feature_send_money_no_recents_subtitle)
  map.put("feature_send_money_not_allowed", Res.string.feature_send_money_not_allowed)
  map.put("feature_send_money_oops", Res.string.feature_send_money_oops)
  map.put("feature_send_money_pay_button", Res.string.feature_send_money_pay_button)
  map.put("feature_send_money_phone_number", Res.string.feature_send_money_phone_number)
  map.put("feature_send_money_please_wait", Res.string.feature_send_money_please_wait)
  map.put("feature_send_money_proceed", Res.string.feature_send_money_proceed)
  map.put("feature_send_money_recents_icon_desc", Res.string.feature_send_money_recents_icon_desc)
  map.put("feature_send_money_recents_title", Res.string.feature_send_money_recents_title)
  map.put("feature_send_money_request", Res.string.feature_send_money_request)
  map.put("feature_send_money_scan_qr", Res.string.feature_send_money_scan_qr)
  map.put("feature_send_money_see_all", Res.string.feature_send_money_see_all)
  map.put("feature_send_money_select_transfer_method", Res.string.feature_send_money_select_transfer_method)
  map.put("feature_send_money_selected", Res.string.feature_send_money_selected)
  map.put("feature_send_money_send", Res.string.feature_send_money_send)
  map.put("feature_send_money_something_went_wrong", Res.string.feature_send_money_something_went_wrong)
  map.put("feature_send_money_submit", Res.string.feature_send_money_submit)
  map.put("feature_send_money_tab_beneficiaries", Res.string.feature_send_money_tab_beneficiaries)
  map.put("feature_send_money_tab_recents", Res.string.feature_send_money_tab_recents)
  map.put("feature_send_money_to_account", Res.string.feature_send_money_to_account)
  map.put("feature_send_money_virtual_payment_address", Res.string.feature_send_money_virtual_payment_address)
  map.put("feature_send_money_vpa", Res.string.feature_send_money_vpa)
  map.put("feature_send_money_vpa_mobile_account_number", Res.string.feature_send_money_vpa_mobile_account_number)
  map.put("feature_transfer_amount", Res.string.feature_transfer_amount)
  map.put("feature_transfer_back_to_home", Res.string.feature_transfer_back_to_home)
  map.put("feature_transfer_cancel", Res.string.feature_transfer_cancel)
  map.put("feature_transfer_close", Res.string.feature_transfer_close)
  map.put("feature_transfer_copy", Res.string.feature_transfer_copy)
  map.put("feature_transfer_date", Res.string.feature_transfer_date)
  map.put("feature_transfer_description", Res.string.feature_transfer_description)
  map.put("feature_transfer_error_access_denied_title", Res.string.feature_transfer_error_access_denied_title)
  map.put("feature_transfer_error_invalid_request", Res.string.feature_transfer_error_invalid_request)
  map.put("feature_transfer_error_invalid_request_title", Res.string.feature_transfer_error_invalid_request_title)
  map.put("feature_transfer_error_network", Res.string.feature_transfer_error_network)
  map.put("feature_transfer_error_network_title", Res.string.feature_transfer_error_network_title)
  map.put("feature_transfer_error_server", Res.string.feature_transfer_error_server)
  map.put("feature_transfer_error_server_title", Res.string.feature_transfer_error_server_title)
  map.put("feature_transfer_error_title", Res.string.feature_transfer_error_title)
  map.put("feature_transfer_from_account", Res.string.feature_transfer_from_account)
  map.put("feature_transfer_retry", Res.string.feature_transfer_retry)
  map.put("feature_transfer_to_account", Res.string.feature_transfer_to_account)
}
